import React from "react";
import "containers/Account/Onboarding/Onboarding.css";
import * as GuardianHelper from "components/Account/Guardian/GuardianHelper";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import AxiosConfig from "axiosConfig";
import { connect } from "react-redux";
import CustomBanner from "components/General/Form/CustomBanner";
import GuardianForm from "components/Account/Guardian/GuardianForm";
import * as CONSTANT from "constants/text";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
class OnboardingGuardian extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      relationship: "",
      errorMap: new Map(),
      pageError: "",
    };
  }

  onSaveClicked(event) {
    event.preventDefault();
    this.createGuardianAxiosCall("next");
  }

  onSaveAddMoreClicked(event) {
    event.preventDefault();
    this.createGuardianAxiosCall("more");
  }

  createGuardianAxiosCall(condition) {
    const notify = () => {
      toast("Guardian Invite Sent!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    };
    const notifiedAlready = () => {
      toast("Invitation Already Sent!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    };
    let obj = this;
    if (GuardianHelper.guardianValidate.bind(this)()) {
      let formData = GuardianHelper.createGuardianFormData.bind(this)();

      AxiosConfig.post("guardian/add_guardian/", formData, {})
        .then(function (response) {
          if (response.data["status"] === CONSTANT.BACKEND_SUCCESS) {
            if (condition === "next") {
              notify();
              setTimeout(() => {
                obj.props.dispatch({ type: "LOGIN_SUCCESS" });
                obj.props.history.push(`/`);
              }, 2000);
            } else if (condition === "more") {
              notify();
              setTimeout(() => {
                obj.props.history.push(`/onboarding-add-guardian`);
                window.scrollTo(0, 0);
                window.location.reload();
              }, 2000);
            }
          } else if (response.data["status"] === "Invitation Already Sent") {
            obj.setState({ pageError: "" });
            notifiedAlready();
          } 
          else if (response.data["status"] === "Email sent to guardian who is not the member of Katamundi"){
            obj.setState({ pageError: "Provided email id does not exist, An email has been sent to join Katamundi" });
          }
        })
        .catch(function (error) {
          obj.setState({ pageError: "Validation Error" });
        });
    }
  }

  onSkipClicked(event) {
    event.preventDefault();
    this.props.dispatch({ type: "LOGIN_SUCCESS" });
    this.props.history.push(`/`);
  }

  render() {
    return (
      <div>
        <CustomBanner message="Invite other guardians to your family account." />
        <div className="onboarding_content" style={{ flexGrow: "1" }}>
          {
            <GuardianForm
              onboarding={true}
              name={this.state.name}
              email={this.state.email}
              relationship={this.state.relationship}
              errorMap={this.state.errorMap}
              onDataChange={GuardianHelper.onDataChange.bind(this)}
              onSaveClicked={this.onSaveClicked.bind(this)}
            />
          }

          {this.state.pageError ? (
            <div style={{ textAlign: "center" }}>
              {this.state.pageError}
              <br/>
            </div>
          ) : (
            ""
          )}
          {/* form ends here */}
          <div className="onboarding_button_options">            
            <RoundedButton
              title="&nbsp;&nbsp;&nbsp;Save and add more guardians&nbsp;&nbsp;&nbsp;"
              buttonClassName="background_dark_orange"
              textThemeClassName="text_medium text_white"
              handleOnClick={this.onSaveAddMoreClicked.bind(this)}
            />
            <RoundedButton
              title="&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;"
              buttonClassName="background_dark_orange"
              textThemeClassName="text_medium text_white"
              handleOnClick={this.onSaveClicked.bind(this)}
            />
            <RoundedButton
              title="Skip for now, maybe later."
              buttonClassName="background_white"
              textThemeClassName="text_medium text_dark_orange"
              handleOnClick={this.onSkipClicked.bind(this)}
            />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(OnboardingGuardian);
